var React = require('react');

function Location (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.5922 14.7888C8.35593 15.0144 8.15366 15.1993 8 15.3367C7.84633 15.1993 7.64407 15.0144 7.4078 14.7888C6.85478 14.2607 6.1186 13.5129 5.38384 12.6327C4.64788 11.7511 3.92164 10.7465 3.3813 9.70525C2.83911 8.6604 2.5 7.60897 2.5 6.625C2.5 3.82445 4.93155 1.5 8 1.5C11.0685 1.5 13.5 3.82445 13.5 6.625C13.5 7.60897 13.1609 8.6604 12.6187 9.70525C12.0784 10.7465 11.3521 11.7511 10.6162 12.6327C9.8814 13.5129 9.14522 14.2607 8.5922 14.7888Z","stroke":"currentColor","key":0}),React.createElement("circle",{"cx":"8","cy":"7","r":"2.5","stroke":"currentColor","key":1})]);
}

Location.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Location;

Location.default = Location;
